import { render, staticRenderFns } from "./ActionGridItem.vue?vue&type=template&id=b59f18d2&scoped=true&"
import script from "./ActionGridItem.vue?vue&type=script&lang=js&"
export * from "./ActionGridItem.vue?vue&type=script&lang=js&"
import style0 from "./ActionGridItem.vue?vue&type=style&index=0&id=b59f18d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59f18d2",
  null
  
)

export default component.exports